var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmptyLabelTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_524_2923)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 41C36.8954 41 36 41.8954 36 43V47.25H32V43C32 39.6863 34.6863 37 38 37H41.6667V41H38ZM56.3333 41H49V37H56.3333V41ZM71 41H63.6667V37H71V41ZM82 41H78.3333V37H82C85.3137 37 88 39.6863 88 43V47.25H84V43C84 41.8954 83.1046 41 82 41ZM36 55.75V64.25H32V55.75H36ZM84 64.25V55.75H88V64.25H84ZM36 72.75V77C36 78.1046 36.8954 79 38 79H41.6667V83H38C34.6863 83 32 80.3137 32 77V72.75H36ZM84 77V72.75H88V77C88 80.3137 85.3137 83 82 83H78.3333V79H82C83.1046 79 84 78.1046 84 77ZM49 79H56.3333V83H49V79ZM63.6667 79H71V83H63.6667V79Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.736 62H54.948C54.4176 62 53.9089 62.2107 53.5338 62.5858C53.1587 62.9609 52.948 63.4696 52.948 64C52.948 64.5304 53.1587 65.0391 53.5338 65.4142C53.9089 65.7893 54.4176 66 54.948 66H65.736C66.2664 66 66.7751 65.7893 67.1502 65.4142C67.5253 65.0391 67.736 64.5304 67.736 64C67.736 63.4696 67.5253 62.9609 67.1502 62.5858C66.7751 62.2107 66.2664 62 65.736 62Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 57,
    r: 2,
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 57,
    r: 2,
    fill: "#1A1B43"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_524_2923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyLabelTemplates);
export default __webpack_public_path__ + "static/media/icon-empty-label-templates.de500bc8f82d1692f8b7d69e3589e06c.svg";
export { ForwardRef as ReactComponent };